
const useMimeInfo = () => {
  const mimeTypes = {
    // Imagens
    "jpg": "image/jpeg",
    "jpeg": "image/jpeg",
    "png": "image/png",
    "gif": "image/gif",
    "bmp": "image/bmp",
    "svg": "image/svg+xml",
    "webp": "image/webp",
    "ico": "image/x-icon",

    // Vídeos
    "mp4": "video/mp4",
    "avi": "video/x-msvideo",
    "mov": "video/quicktime",
    "wmv": "video/x-ms-wmv",
    "flv": "video/x-flv",
    "webm": "video/webm",
    "mkv": "video/x-matroska",

    // Áudios
    "mp3": "audio/mpeg",
    "wav": "audio/wav",
    "ogg": "audio/ogg",
    "aac": "audio/aac",
    "flac": "audio/flac",
    "midi": "audio/midi",

    // Documentos
    "pdf": "application/pdf",
    "doc": "application/msword",
    "docx": "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    "xls": "application/vnd.ms-excel",
    "xlsx": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    "ppt": "application/vnd.ms-powerpoint",
    "pptx": "application/vnd.openxmlformats-officedocument.presentationml.presentation",
    "txt": "text/plain",
    "csv": "text/csv",
    "json": "application/json",
    "xml": "application/xml",

    // Compactação & Binários
    "zip": "application/zip",
    "rar": "application/vnd.rar",
    "7z": "application/x-7z-compressed",
    "tar": "application/x-tar",
    "gz": "application/gzip",
    "exe": "application/vnd.microsoft.portable-executable",
    "iso": "application/x-iso9660-image",

    // Web & Scripts
    "html": "text/html",
    "css": "text/css",
    "js": "application/javascript",
    "php": "application/x-httpd-php",
    "wasm": "application/wasm",

    // Segurança & Certificados
    "pem": "application/x-pem-file",
    "crt": "application/x-x509-ca-cert",
    "cer": "application/pkix-cert",
    "p12": "application/x-pkcs12"
  };

  return {
    mimeTypes
  };
}

export default useMimeInfo;